var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.171,
    height: 13,
    viewBox: "0 0 16.171 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-cloud-seeklogo.com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115113",
    "data-name": "Path 115113",
    d: "M39.531,3.589l1.406-1.406.094-.592a6.332,6.332,0,0,0-8.943.551,6.5,6.5,0,0,0-1.371,2.568l.5-.071,2.811-.464.217-.222a3.522,3.522,0,0,1,4.809-.39Z",
    transform: "translate(-28.776)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115114",
    "data-name": "Path 115114",
    d: "M128.454,28.274a6.333,6.333,0,0,0-1.909-3.078l-1.973,1.973a3.507,3.507,0,0,1,1.287,2.782v.35a1.746,1.746,0,1,1,0,3.492h-3.517l-.345.375v2.106l.345.33h3.517a4.554,4.554,0,0,0,2.594-8.33",
    transform: "translate(-114.291 -23.605)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115115",
    "data-name": "Path 115115",
    d: "M30.981,161.761h3.512V158.95H30.981a1.723,1.723,0,0,1-.72-.158l-.5.153-1.416,1.406-.123.478a4.557,4.557,0,0,0,2.757.932",
    transform: "translate(-26.44 -148.761)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115116",
    "data-name": "Path 115116",
    d: "M4.54,61.425a4.567,4.567,0,0,0-2.757,8.187L3.82,67.576a1.756,1.756,0,1,1,2.323-2.323L8.18,63.215a4.562,4.562,0,0,0-3.64-1.79",
    transform: "translate(0 -57.545)",
    fill: "#fbbc05"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloud);
export default __webpack_public_path__ + "static/media/google-cloud.7510607437786fb22d57a3c9285b6799.svg";
export { ForwardRef as ReactComponent };